import { useLocale } from '@/contexts/LocaleContext';
import { useState, useEffect } from 'react';
import { Outlet, NavLink, Navigate, useLocation } from 'react-router-dom';
import { useHubTabs } from '@/lib/permisos';
import { BarChart3, Eye, ListChecks } from 'lucide-react';
import api from '@/lib/api';

const TABS = [
  { key: 'status', path: '/tenant/reports/status', labelKey: 'rep.status', icon: ListChecks, module: 'reports' },
  { key: 'observability', path: '/tenant/reports/observability', labelKey: 'rep.detail', icon: Eye, gate: 'observability_enabled', module: 'reports' },
];

export default function ReportsHubLayout() {
  const { tabs: visibleTabs } = useHubTabs(TABS);
  const _allTabs = TABS;
  const { t } = useLocale();
  const location = useLocation();
  const [limits, setLimits] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/tenant/reports/limits')
      .then(r => setLimits(r.data || {}))
      .catch(() => setLimits({}))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="w-8 h-8 border-2 border-[#E2E8F0] border-t-[#0F172A] rounded-full animate-spin" />
      </div>
    );
  }

  if (location.pathname === '/tenant/reports' || location.pathname === '/tenant/reports/') {
    return <Navigate to="/tenant/reports/status" replace />;
  }

  return (
    <div className="space-y-5" data-testid="reports-hub">
      <div>
        <h1 className="text-2xl font-bold text-[#0F172A] tracking-tight flex items-center gap-2">
          <BarChart3 className="w-6 h-6" /> Reportes
        </h1>
        <p className="text-sm text-[#64748B] mt-1">Métricas y observabilidad operacional</p>
      </div>

      <div className="flex gap-1 border-b border-[#E2E8F0] overflow-x-auto" data-testid="reports-hub-tabs">
        {/* filtered */ visibleTabs.map(tab => {
          const enabled = tab.gate ? limits?.[tab.gate] !== false : true;
          return (
            <NavLink
              key={tab.key}
              to={enabled ? tab.path : '#'}
              onClick={e => { if (!enabled) e.preventDefault(); }}
              data-testid={`reports-tab-${tab.key}`}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
                  !enabled ? 'border-transparent text-[#CBD5E1] cursor-not-allowed' :
                  isActive ? 'border-[#0F172A] text-[#0F172A]' : 'border-transparent text-[#64748B] hover:text-[#0F172A]'
                }`
              }
            >
              <tab.icon className="w-4 h-4" /> {tab.labelKey ? t(tab.labelKey) : tab.label}
            </NavLink>
          );
        })}
      </div>

      <Outlet />
    </div>
  );
}
